(function (ws) {
    'use strict';

    ws.views.minicart = Backbone.View.extend({

        events: {
            mouseenter: 'showCart',
            mouseleave: 'hideCart'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.template = _.template($('#comp-minicart').html());
            this.model = new ws.models.minicart();

            this.listenTo(this.model, 'change', this.render);

            this.render();

            // register event to trigger and update the cart
            this.eventAgg.on('updateCart', this.fetchData.bind(this));
            this.fetchData();
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template(this.model.toJSON()));
            this.$spinner = $('.mic-spinner').hide();
            this.$overlay = $('.mic-cart-overlay').hide();
            this.$spinner.hide();
        },

        /**
         * Fetch Data Model
         */
        fetchData: function (data) {
            if ((data) && (data !== undefined)) {
                this.model.set(data);
            } else {
                this.$spinner.show();
                this.model.fetch({
                    cache: false,
                    error: this._handleFetchError.bind(this)
                });
            }

            this.$spinner.hide();
        },

        /**
         * Alerts you when there's error fetching the mini cart
         * @protected
         */
        _handleFetchError: function () {
            console.error('Error fetching Mini Cart!');
        },

        showCart: function () {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.$overlay.fadeIn(250);
            this.eventAgg.trigger('minicartOpened');
        },

        hideCart() {
            this.timeout = setTimeout(() => {
                this.$overlay.fadeOut(250);
                this.timeout = null;
            }, 2000);
        }
    });
})(westcon);

